import { StyledMainGallery } from '@/components/styles';
import { Picture } from '@/components';
import Swiper from 'react-id-swiper';

export default function MainGallery({ data }) {

  const params = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    preloadImages: false,
    resistanceRatio: 0,
    watchOverflow: true,
    keyboard: true,
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      clickable: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    preventInteractionOnTransition: true,
  };


  return (
    <StyledMainGallery>
      
      <Swiper {...params}>

            
        {data.map((item) => {
          const { id, image, banner_alt, title } = item;

          const img = image || {};
          const imageAlt = banner_alt || title || '';

          return (
            <StyledMainGallery.Item key={id}>
              <StyledMainGallery.Img>{Object.keys(image).length > 0 && <Picture {...img} alt={imageAlt} isLazy={true}/>}</StyledMainGallery.Img>
            </StyledMainGallery.Item>
          );
        })}
          
      </Swiper>
    </StyledMainGallery>
  );
}
